import { useRouteError } from 'react-router-dom';

export class RouterError extends Error {
  statusText?: string;

  status: number;

  override message: string;

  override stack?: string;

  config?: unknown;

  code?: string;

  request?: unknown;

  response?: unknown;

  isAxiosError?: boolean;

  constructor(message: string, statusCode: number) {
    super(message);
    this.status = statusCode;
    this.message = message;
  }

  toJSON = (): RouterError => {
    return {
      message: this.message,
      status: this.status,
      name: this.name,
      stack: this.stack,
      config: this.config,
      code: this.code,
      request: this.request,
      response: this.response,
      isAxiosError: this.isAxiosError,
      toJSON: this.toJSON,
    };
  };
}

interface ErrorPageProps {
  message?: string;
}

const ErrorPage = (props: ErrorPageProps) => {
  const error = (useRouteError() as RouterError | undefined) ?? {
    message: props.message,
    statusText: '',
  };

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>
          {error.statusText} {error.message}
        </i>
      </p>
    </div>
  );
};

export default ErrorPage;
